export default __webpack_public_path__ + "47777cc5.svg";